export default __webpack_public_path__ + "static/lifecycle-stages-a468ef23f3603531adcc8116dbd7a4f7.png";